import { FC } from "react"
import bee from 'assets/images/bee-ok.png'
import { useTranslation } from "react-i18next"

const SectionTarget: FC = () => {
  const { t } = useTranslation()
  const list = [[1,1,1,1,1],[1,1,1,1],[1,1,1],[1,1],[1]]
  const letters = ['A','B','C','D',null]

  return (
      <>
        <div>
            {list.map((r,x) => <div key={x} style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                {r.map((c,y) => 
                  <div key={y}>
                    <img src={bee} />
                  </div>)
                }
                <div>
                  {letters[x] && <span>
                      <span style={{ fontSize: '20px', fontWeight: '400'}}>{t('dashboard.for-an')} </span>
                      <span style={{ fontSize: '26px', fontWeight: '600'}}> {letters[x]}</span>
                    </span>}
                </div>
            </div>)}   
        </div>
    </>
  )
}

export default SectionTarget
